import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { ItemGridContainer } from '../../containers/assignEntities/ItemGridContainer';
import { SiteGroupGridContainer } from '../../containers/assignEntities/SiteGroupGridContainer';

const AssignSiteGroupsToItemsWithStorageLocation = props => {
  const {
    siteGroupData,
    allItemsData,
    setIsReadOnlyState,
    isReadOnly,
    setItemGridInstance,
    isRightGridFiltered,
    onRightGridFilteredChange,
    rightSideGridReactTableRef,
    isLeftGridFiltered,
    leftSideGridReactTableRef,
    onLeftGridFilteredChange,
    resetGridPage,
    onResetPageOnDataChange,
  } = props;

  return (
    <Grid>
      <Grid.Row
        columns={2}
        style={{
          marginTop: -15,
        }}
      >
        <Grid.Column width={6}>
          <Field
            component={SiteGroupGridContainer}
            name={AssignEntitiesEnum.SiteGroupGridInfo}
            {...{
              dataSource: siteGroupData,
              isStorageLocationPage: true,
              setIsReadOnlyState,
              isReadOnly,
              isLeftGridFiltered,
              leftSideGridReactTableRef,
              onLeftGridFilteredChange,
              resetGridPage,
              onResetPageOnDataChange,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={ItemGridContainer}
            name={AssignEntitiesEnum.ItemGridInfo}
            {...{
              dataSource: allItemsData,
              isStorageLocationPage: true,
              setIsReadOnlyState,
              isReadOnly,
              setItemGridInstance,
              isRightGridFiltered,
              onRightGridFilteredChange,
              rightSideGridReactTableRef,
              resetGridPage,
              onResetPageOnDataChange,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignSiteGroupsToItemsWithStorageLocation.propTypes = {
  siteGroupData: PropTypes.array.isRequired,
  allItemsData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  onRightGridFilteredChange: PropTypes.func,
  onLeftGridFilteredChange: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  setIsReadOnlyState: PropTypes.func,
  setItemGridInstance: PropTypes.func,
  isReadOnly: PropTypes.bool,
  isRightGridFiltered: PropTypes.bool,
  isLeftGridFiltered: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
  leftSideGridReactTableRef: PropTypes.object,
};

AssignSiteGroupsToItemsWithStorageLocation.defaultProps = {
  isReadOnly: true,
  isRightGridFiltered: false,
  isLeftGridFiltered: false,
  rightSideGridReactTableRef: null,
  leftSideGridReactTableRef: null,
  setIsReadOnlyState: () => {},
  setItemGridInstance: () => {},
  onRightGridFilteredChange: () => {},
  onLeftGridFilteredChange: () => {},
  onResetPageOnDataChange: () => {},
};
export default AssignSiteGroupsToItemsWithStorageLocation;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/storageLocation/AssignSiteGroupsToItemsWithStorageLocation.js